<template>
  <div
    class="tour-slot-box"
    :class="{
      'is-guide-active': shareStore.tourGuideVisible,
      'w-100': props.autoWidth,
    }"
  >
    <!-- 自定义按钮插槽 -->
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useShare } from '@/store/share'

const shareStore = useShare()

const props = defineProps<{
  autoWidth?: boolean
}>()
</script>

<style lang="less" scoped>
.tour-slot-box {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.w-100 {
  width: 100%;
}

.is-guide-active {
  &:before {
    box-sizing: border-box;
    pointer-events: none;
    content: '';
    width: calc(100% + 10px);
    height: calc(100% + 10px);
    border-radius: 9px;
    left: -5px;
    top: -5px;
    position: absolute;
    z-index: 999;
    border: 1px solid var(--color-primary);
  }
}
</style>
